import Footer from 'components/organisms/Footer/GlobalFooter';
import Header from 'components/organisms/Header/HomeHeader';
import Body from 'views/MobileViews/FeaturedArtistsBody';

const FeaturedArtists = () => {
  return (
    <>
      <Header />
      <Body />
      <Footer />
    </>
  );
};

export default FeaturedArtists;
